<div *ngIf="open" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col">
    <div class="flex items-center justify-between px-4 py-3 border-b">
      <h3 class="font-semibold text-gray-800">
        <i class="fas fa-paper-plane text-blue-600 mr-2"></i>Confirmar reporte a la aseguradora
      </h3>
      <button (click)="closeReportModal()" class="text-gray-400 hover:text-gray-700"><i class="fas fa-times"></i></button>
    </div>

    <div class="p-4 overflow-auto" *ngIf="payment as p">
      <p class="text-sm text-gray-500 mb-3">Revisa el detalle antes de reportar. Esta acción notifica el pago a Seguros Mercantil y queda registrada a tu nombre.</p>

      <!-- Cliente -->
      <div class="flex items-center gap-3 mb-3 p-2 bg-gray-50 rounded">
        <img [src]="personPhoto(p)" class="rounded-circle border" style="object-fit:cover;width:44px;height:44px;" alt="cliente" />
        <div>
          <div class="font-medium text-gray-800">{{ p.person?.name || '—' }}</div>
          <div class="text-xs text-gray-400">{{ p.person?.cedula || p.person?.code || '' }}</div>
        </div>
      </div>

      <!-- Detalle -->
      <dl class="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
        <dt class="text-gray-500">Póliza</dt>
        <dd class="text-gray-800 font-medium">
          <span *ngIf="prDetailLoading" class="text-xs text-gray-400">
            <i class="fas fa-spinner fa-spin mr-1"></i>Cargando detalle…
          </span>
          <ng-container *ngIf="!prDetailLoading">
            <ng-container *ngIf="prDetail?.policies?.length; else polFallback">
              <div *ngFor="let pol of prDetail.policies" class="mb-1.5 last:mb-0">
                <div class="font-medium text-gray-800">
                  {{ pol.product_name || prProductLabel(p) }}
                  <span *ngIf="pol.product_code" class="text-xs text-gray-400">({{ pol.product_code }})</span>
                </div>
                <div class="text-xs text-gray-500">
                  N° {{ pol.policy_number || '—' }}<span *ngIf="pol.frequency"> · {{ pol.frequency | titlecase }}</span>
                </div>
                <div class="text-[11px] text-gray-400 font-mono break-all">{{ pol.policy_code }}</div>
              </div>
            </ng-container>
            <ng-template #polFallback>
              {{ prProductLabel(p) }}
              <div class="text-xs text-gray-400 font-mono break-all">{{ p.policy_code || p.insurance_report?.policy_code || '—' }}</div>
            </ng-template>
          </ng-container>
        </dd>

        <dt class="text-gray-500">Monto</dt>
        <dd class="text-gray-800 font-medium">{{ p.amount }}</dd>

        <dt class="text-gray-500">Tasa</dt>
        <dd class="text-gray-800">{{ p.rate || p.insurance_report?.change_rate || '—' }}</dd>

        <dt class="text-gray-500">Banco</dt>
        <dd class="text-gray-800">{{ p.bank?.name || p.bank?.code || '—' }}</dd>

        <dt class="text-gray-500">Referencia</dt>
        <dd class="text-gray-800 font-mono text-xs break-all">{{ p.insurance_report?.reference || p.reference || '—' }}</dd>

        <dt class="text-gray-500">Fecha del pago</dt>
        <dd class="text-gray-800">{{ p.date | date:'dd/MM/yyyy' }}</dd>

        <dt class="text-gray-500">Tipo</dt>
        <dd class="text-gray-800">
          <ng-container *ngIf="prDetail?.cuotas_count">
            <span *ngIf="prDetail.is_multi">Multi-cuota ({{ prDetail.cuotas_count }} cuotas)</span>
            <span *ngIf="!prDetail.is_multi">Cuota única</span>
          </ng-container>
          <ng-container *ngIf="!prDetail?.cuotas_count">
            <span *ngIf="prIsMulti(p)">Multi-cuota ({{ p.insurance_report?.installment_codes?.length }} cuotas)</span>
            <span *ngIf="!prIsMulti(p)">Cuota única</span>
          </ng-container>
        </dd>

        <dt class="text-gray-500">Intentos previos</dt>
        <dd class="text-gray-800">{{ p.insurance_report?.current_intento || 0 }} / {{ p.insurance_report?.limite || 10 }}</dd>

        <dt class="text-gray-500">Código de pago</dt>
        <dd class="text-gray-800 font-mono text-xs break-all">{{ p.code }}</dd>
      </dl>

      <!-- Cuotas que cubre el pago (resueltas desde la BD) -->
      <div *ngIf="prDetail?.policies?.length" class="mt-3">
        <div class="text-xs font-medium text-gray-600 mb-1.5">
          <i class="fas fa-receipt text-gray-400 mr-1"></i>Cuotas cubiertas por el pago
          <span class="text-gray-400">({{ prDetail.cuotas_count }})</span>
        </div>
        <div *ngFor="let pol of prDetail.policies" class="mb-2 last:mb-0">
          <div *ngIf="prDetail.policies.length > 1" class="text-[11px] text-gray-500 mb-1">
            {{ pol.product_name || 'Póliza' }} · N° {{ pol.policy_number || pol.policy_code }}
          </div>
          <div class="flex flex-wrap gap-1">
            <span *ngFor="let c of pol.cuotas"
              class="inline-flex items-center gap-1 text-[11px] bg-gray-100 text-gray-700 rounded px-2 py-0.5">
              <i class="fas fa-hashtag text-gray-400 text-[9px]"></i>Cuota {{ c.cuota_order }}
              <span *ngIf="c.receipt_number" class="text-gray-400">· recibo {{ c.receipt_number }}</span>
            </span>
          </div>
        </div>
      </div>

      <!-- Aviso si nunca se ha intentado / backfill -->
      <div *ngIf="!p.insurance_report || p.insurance_report?.current_intento === 0"
        class="mt-3 text-xs text-blue-700 bg-blue-50 rounded p-2">
        <i class="fas fa-info-circle mr-1"></i>Primer reporte de este pago a la aseguradora.
      </div>

      <!-- ====== Comparación: cuota PAGADA (distribuida) vs cuota A REPORTAR ====== -->
      <div *ngIf="prDryRunning" class="mt-3 text-xs text-gray-500">
        <i class="fas fa-spinner fa-spin mr-1"></i>Preparando comparación…
      </div>

      <div *ngIf="!prDryRunning && prReportBlocked" class="mt-3 rounded border border-red-300 bg-red-50 px-3 py-2 text-xs text-red-800">
        <i class="fas fa-ban mr-1"></i><b>No se puede reportar:</b>
        {{ prDryRunResult?.error || prDryRunResult?.message || 'Verifica la cuota y el recibo de este pago.' }}
      </div>

      <div *ngIf="!prDryRunning && !prReportBlocked && prComparisonRows.length" class="mt-3">
        <div class="text-xs font-semibold text-gray-700 mb-1">
          <i class="fas fa-balance-scale mr-1 text-blue-600"></i>Verifica antes de confirmar: cuota pagada vs. cuota a reportar
        </div>
        <div class="overflow-x-auto border rounded">
          <table class="min-w-full text-xs">
            <thead class="bg-gray-50 text-gray-600">
              <tr>
                <th class="text-left px-2 py-1">Distribuido (pago)</th>
                <th class="text-left px-2 py-1">A reportar (SM)</th>
                <th class="text-center px-2 py-1">Monto</th>
                <th class="text-center px-2 py-1"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of prComparisonRows" class="border-t" [class.bg-red-50]="!r.match">
                <td class="px-2 py-1">Cuota <b>{{ r.cuota_dist }}</b> · recibo <span class="font-mono">{{ r.receipt_dist }}</span></td>
                <td class="px-2 py-1">Cuota <b>{{ r.cuota_rep ?? '—' }}</b> · recibo <span class="font-mono">{{ r.receipt_rep ?? '—' }}</span></td>
                <td class="px-2 py-1 text-center">{{ r.pending | number:'1.2-2' }} USD</td>
                <td class="px-2 py-1 text-center">
                  <span *ngIf="r.match" class="text-emerald-600"><i class="fas fa-check-circle"></i> coincide</span>
                  <span *ngIf="!r.match" class="text-red-600"><i class="fas fa-exclamation-triangle"></i> revisar</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="prComparisonRows[0]?.sm_difiere" class="mt-1 text-[11px] text-amber-700">
          <i class="fas fa-info-circle mr-1"></i>SM tenía como “próximo” la cuota {{ prComparisonRows[0].sm_proximo_cuota }} (recibo {{ prComparisonRows[0].sm_proximo_recibo }}). Se reportará la cuota <b>{{ prComparisonRows[0].cuota_dist }}</b> — la que realmente pagó este pago.
        </div>
      </div>

      <!-- Detalle técnico (colapsable): endpoint y JSON que se enviará -->
      <details class="mt-3 border rounded overflow-hidden" [open]="!!prDryRunResult">
        <summary class="cursor-pointer select-none px-3 py-2 text-xs font-medium text-gray-600 bg-gray-50 hover:bg-gray-100 flex items-center gap-2">
          <i class="fas fa-code text-gray-400"></i>
          Ver endpoint y JSON que se enviará
        </summary>
        <div class="border-t bg-gray-900 px-3 py-2">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[11px] uppercase tracking-wide text-gray-400">POST · request body vacío <span class="text-gray-500">{{ '{}' }}</span></span>
            <button type="button" (click)="copyReportPreview()" class="text-[11px] text-blue-300 hover:text-blue-200">
              <i class="fas fa-copy mr-1"></i>Copiar JSON
            </button>
          </div>
          <pre class="m-0 text-[11px] leading-relaxed text-green-300 whitespace-pre-wrap break-all">{{ prReportJsonPreview }}</pre>
          <p class="mt-2 mb-0 text-[11px] text-gray-400">
            Solo viaja el código del pago en la URL; el backend deriva póliza, cuotas y montos desde la BD antes de reportar a la aseguradora.
          </p>
        </div>

        <!-- Resultado del dry-run: traza REAL devuelta por el backend (sin ejecutar el reporte) -->
        <div *ngIf="prDryRunResult" class="border-t border-amber-300 bg-amber-50 px-3 py-2">
          <div class="flex items-center justify-between mb-2">
            <span class="text-[11px] font-semibold uppercase tracking-wide text-amber-700">
              <i class="fas fa-vial mr-1"></i>Traza real (dry run) — nada fue enviado ni guardado
            </span>
            <button type="button" (click)="copyDryRunResult()" class="text-[11px] text-amber-700 hover:text-amber-900">
              <i class="fas fa-copy mr-1"></i>Copiar traza
            </button>
          </div>

          <p *ngIf="prDryRunResult.message" class="text-[11px] text-amber-800 mb-2">{{ prDryRunResult.message }}</p>

          <!-- Llamadas internas, paso a paso (método + URL + payload) -->
          <div *ngIf="prDryRunResult.trace_steps?.length" class="space-y-2 mb-2">
            <div *ngFor="let step of prDryRunResult.trace_steps" class="rounded border border-gray-200 bg-white overflow-hidden">
              <div class="flex items-center gap-2 px-2 py-1.5 text-[11px]">
                <span class="font-mono font-bold text-white px-1.5 py-0.5 rounded text-[10px]"
                  [ngClass]="step.method === 'POST' ? 'bg-blue-600' : 'bg-emerald-600'">{{ step.method }}</span>
                <span class="font-mono text-gray-700 break-all flex-1">{{ step.url }}</span>
                <span class="text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap"
                  [ngClass]="{
                    'bg-emerald-100 text-emerald-700': step.result === 'OK',
                    'bg-amber-100 text-amber-700': step.result === 'would_send',
                    'bg-red-100 text-red-700': step.result === 'ERROR',
                    'bg-gray-100 text-gray-600': step.result === 'pending'
                  }">{{ step.result === 'would_send' ? 'NO se envía' : step.result }}</span>
              </div>
              <pre *ngIf="step.payload" class="m-0 border-t bg-gray-900 px-2 py-1.5 text-[10px] leading-relaxed text-green-300 whitespace-pre-wrap break-all max-h-56 overflow-auto">{{ step.payload | json }}</pre>
              <pre *ngIf="step.error" class="m-0 border-t px-2 py-1.5 text-[10px] text-red-700 whitespace-pre-wrap break-all max-h-40 overflow-auto">{{ step.error | json }}</pre>
            </div>
          </div>

          <!-- Si no hubo pasos (error temprano), mostrar el would_call directo -->
          <div *ngIf="!prDryRunResult.trace_steps?.length && prDryRunResult.would_call" class="rounded border border-gray-200 bg-white overflow-hidden mb-2">
            <div class="flex items-center gap-2 px-2 py-1.5 text-[11px]">
              <span class="font-mono font-bold text-white bg-blue-600 px-1.5 py-0.5 rounded text-[10px]">{{ prDryRunResult.would_call.method }}</span>
              <span class="font-mono text-gray-700 break-all flex-1">{{ prDryRunResult.would_call.url }}</span>
              <span class="text-[10px] px-1.5 py-0.5 rounded bg-amber-100 text-amber-700">NO se envía</span>
            </div>
            <pre class="m-0 border-t bg-gray-900 px-2 py-1.5 text-[10px] leading-relaxed text-green-300 whitespace-pre-wrap break-all max-h-56 overflow-auto">{{ prDryRunResult.would_call.payload | json }}</pre>
          </div>

          <!-- JSON completo de la traza, por si quieren el detalle crudo -->
          <details class="mt-1">
            <summary class="text-[10px] text-amber-700 cursor-pointer select-none">Ver JSON completo de la traza</summary>
            <pre class="m-0 mt-1 text-[10px] leading-relaxed text-gray-800 whitespace-pre-wrap break-all max-h-72 overflow-auto">{{ prDryRunJson }}</pre>
          </details>

          <p class="mt-2 mb-0 text-[11px] text-amber-700">
            Las filas <span class="font-semibold">GET</span> son lecturas que sí se ejecutan (solo lectura); la fila <span class="font-semibold">POST</span> es el request exacto que se enviaría a la aseguradora al confirmar — aquí <span class="font-semibold">no se envía</span>.
          </p>
        </div>
      </details>
    </div>

    <div class="px-4 py-3 border-t flex justify-end gap-2">
      <button (click)="closeReportModal()" [disabled]="prReporting || prDryRunning"
        class="px-3 py-1.5 bg-gray-100 text-gray-700 rounded text-sm disabled:opacity-50">Cancelar</button>
      <button (click)="simulateReport()" [disabled]="prReporting || prDryRunning"
        class="px-3 py-1.5 bg-amber-100 text-amber-800 rounded text-sm disabled:opacity-50"
        title="Simula todo el flujo sin enviar nada a la aseguradora">
        <i class="fas mr-1" [ngClass]="prDryRunning ? 'fa-spinner fa-spin' : 'fa-vial'"></i>
        {{ prDryRunning ? 'Simulando…' : 'Simular (dry run)' }}
      </button>
      <button (click)="confirmReport()" [disabled]="prReporting || prDryRunning || prReportBlocked"
        [title]="prReportBlocked ? 'Hay un bloqueo (pago parcial / sin recibo / discrepancia). No se puede reportar.' : ''"
        class="px-3 py-1.5 bg-blue-600 text-white rounded text-sm disabled:opacity-50">
        <i class="fas mr-1" [ngClass]="prReporting ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
        {{ prReporting ? 'Reportando…' : 'Confirmar reporte' }}
      </button>
    </div>
  </div>
</div>
